// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

import { MonolithImageSizeFragmentDoc } from '../monolithImageSize.fragment.generated';
export const ReviewsFragmentDoc = `
    fragment reviews on Review {
  id
  name
  comment
  date
  picture {
    id
    url
    small: size(name: SMALL) {
      ...monolithImageSize
    }
    small_x2: size(name: SMALL_X2) {
      ...monolithImageSize
    }
  }
  rating
}
    `;